import { render, staticRenderFns } from "./AddOrUpdateApplicationsModal.vue?vue&type=template&id=95b66c4a"
import script from "./AddOrUpdateApplicationsModal.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateApplicationsModal.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateApplicationsModal.vue?vue&type=style&index=0&id=95b66c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports